const MAX_TRACE_EVENTS = 2000
const traceEvents = []

export function recordPerfEvent(name, data = {}) {
  traceEvents.push({
    name,
    ts: performance.now(),
    ...data,
  })
  if (traceEvents.length > MAX_TRACE_EVENTS) {
    traceEvents.splice(0, traceEvents.length - MAX_TRACE_EVENTS)
  }
}

export function markPerf(name, data) {
  const start = performance.now()
  return (extra = {}) => {
    const duration = performance.now() - start
    recordPerfEvent(name, { duration, ...data, ...extra })
    return duration
  }
}

export function getPerfTrace() {
  return [...traceEvents]
}

export function clearPerfTrace() {
  traceEvents.length = 0
}

export function buildPerfTraceSnapshot(extra = {}) {
  return {
    createdAt: new Date().toISOString(),
    userAgent: navigator.userAgent,
    devicePixelRatio: window.devicePixelRatio || 1,
    events: getPerfTrace(),
    ...extra,
  }
}
